module.exports = __webpack_public_path__ + "static/images/TitleLogo.064edd04.jpg";